"use strict";

(() => {
	class Tax_Calculator {
		/** @var {HTMLElement} */
		#$widget;

		/** @var {HTMLSelectElement} */
		#$taxRateInput;

		/** @var {HTMLInputElement} */
		#$customTaxRateInput;

		/** @var {HTMLInputElement} */
		#$priceExclTaxInput;

		/** @var {HTMLInputElement} */
		#$taxInput;

		/** @var {HTMLInputElement} */
		#$priceInclTaxInput;


		constructor($widget) {
			this.#$widget = $widget;
		}

		initialize() {
			// Initialize inputs.
			this.#$taxRateInput       = this.#$widget.querySelector(".dan-input-tax-rate");
			this.#$customTaxRateInput = this.#$widget.querySelector(".dan-input-custom-tax-rate");
			this.#$priceExclTaxInput  = this.#$widget.querySelector(".dan-input-price-excl-tax");
			this.#$taxInput           = this.#$widget.querySelector(".dan-input-tax");
			this.#$priceInclTaxInput  = this.#$widget.querySelector(".dan-input-price-incl-tax");

			// Attach handlers to events.
			this.#$taxRateInput.addEventListener("change", (this.#onTaxRateChange).bind(this));
			this.#$customTaxRateInput.addEventListener("input", (this.#onTaxRateChange).bind(this));
			this.#$priceExclTaxInput.addEventListener("input", (this.#recalcByPriceExclTax).bind(this));
			this.#$taxInput.addEventListener("input", (this.#recalcByTax).bind(this));
			this.#$priceInclTaxInput.addEventListener("input", (this.#recalcByTaxInclTax).bind(this));

			// Calc on load.
			this.#recalcByPriceExclTax();
		}

		#onTaxRateChange() {
			// Refresh custom tax rate input visibility.
			const $inputWrapper = this.#$widget.querySelector(".dan-custom-tax-rate-wrapper");
			const inputShown    = $inputWrapper.classList.contains("-active");

			if (this.#$taxRateInput.value === "custom" && !inputShown) {
				$inputWrapper.style.height = "0px";

				setTimeout(() => {
					$inputWrapper.style.height = $inputWrapper.scrollHeight + "px";
				}, 25);

				setTimeout(() => {
					$inputWrapper.style.height = "auto";
					$inputWrapper.classList.add("-active");
				}, 175);
			} else if (this.#$taxRateInput.value !== "custom" && inputShown) {
				$inputWrapper.style.height = $inputWrapper.scrollHeight + "px";

				setTimeout(() => {
					$inputWrapper.style.height = "0px";
				}, 25);

				setTimeout(() => {
					$inputWrapper.classList.remove("-active");
				}, 175);
			}

			// Recalc by tax excl. tax.
			this.#recalcByPriceExclTax();
		}

		#recalcByPriceExclTax() {
			const inputs = this.getInputs();

			if (inputs.taxRate === null || inputs.priceExclTax === null) {
				this.#$taxInput.value = "";
				this.#$priceInclTaxInput.value = "";
				return;
			}

			const tax          = (inputs.priceExclTax / 100 * inputs.taxRate);
			const priceInclTax = (inputs.priceExclTax + tax);

			this.#$taxInput.value          = (Math.round(tax * 100) / 100).toString();
			this.#$priceInclTaxInput.value = (Math.round(priceInclTax * 100) / 100).toString();
		}

		#recalcByTax() {
			const inputs = this.getInputs();

			if (inputs.taxRate === null || inputs.tax === null) {
				this.#$priceExclTaxInput.value = "";
				this.#$priceInclTaxInput.value = "";
				return;
			}

			const priceExclTax = (inputs.tax / inputs.taxRate * 100);
			const priceInclTax = (priceExclTax + inputs.tax);

			this.#$priceExclTaxInput.value = (Math.round(priceExclTax * 100) / 100).toString();
			this.#$priceInclTaxInput.value = (Math.round(priceInclTax * 100) / 100).toString();
		}

		#recalcByTaxInclTax() {
			const inputs = this.getInputs();

			if (inputs.taxRate === null || inputs.priceInclTax === null) {
				this.#$priceExclTaxInput.value = "";
				this.#$taxInput.value = "";
				return;
			}

			const priceExclTax = (inputs.priceInclTax / (100 + inputs.taxRate) * 100);
			const tax          = (inputs.priceInclTax - priceExclTax);

			this.#$priceExclTaxInput.value = (Math.round(priceExclTax * 100) / 100).toString();
			this.#$taxInput.value          = (Math.round(tax * 100) / 100).toString();
		}

		getInputs() {
			// Tax rate.
			let taxRate = (this.#$taxRateInput.value === "custom")
				? parseFloat(this.#$customTaxRateInput.value)
				: parseFloat(this.#$taxRateInput.value);

			if (isNaN(taxRate) || taxRate < 0) {
				taxRate = null;
			}

			// Price excl. tax.
			let priceExclTax;
			priceExclTax = this.#$priceExclTaxInput.value || this.#$priceExclTaxInput.placeholder;
			priceExclTax = parseFloat(priceExclTax);

			if (isNaN(priceExclTax) || priceExclTax < 0) {
				priceExclTax = null;
			}

			// Tax.
			let tax = parseFloat(this.#$taxInput.value);

			if (isNaN(tax) || tax < 0) {
				tax = null;
			}

			// Price incl. tax.
			let priceInclTax = parseFloat(this.#$priceInclTaxInput.value);

			if (isNaN(priceInclTax) || priceInclTax < 0) {
				priceInclTax = null;
			}

			// Return.
			return {
				taxRate,
				priceExclTax,
				tax,
				priceInclTax
			};
		}
	}

	// Initialize widgets.
	const $widgets = document.querySelectorAll(".dan-tax-calculator");

	for (const $widget of $widgets) {
		$widget.calculator = new Tax_Calculator($widget);
		$widget.calculator.initialize();
	}
})();
